import { initContract } from "@ts-rest/core";
import { CountResponseSchema } from "@common/schemas/count-response.schema";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    ListOrganizationThreadsQuerySchema,
    ListOrganizationThreadsResponseSchema,
    OrganizationChatQuerySchema,
} from "@common/schemas/chat.schema";

const c = initContract();

export const organizationChatContract = c.router(
    {
        getThreads: {
            method: "GET",
            path: "/threads",
            query: ListOrganizationThreadsQuerySchema,
            responses: {
                200: ListOrganizationThreadsResponseSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        getNumberOfUnreadMessages: {
            method: "GET",
            path: "/messages/unread",
            query: OrganizationChatQuerySchema,
            responses: {
                200: CountResponseSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/organization-chat",
    },
);
